import { render } from "./FAQ.vue?vue&type=template&id=5c73bc45&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=5c73bc45&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c73bc45"]])

export default __exports__